const styles = theme => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  layout: {
    display: 'flex',
    alignItems: 'flex-start',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '1.5rem',
    gap: '2rem',
    '@media (max-width: 800px)': {
      flexDirection: 'column',
      padding: '1rem',
      gap: '1rem',
    },
  },
  sidebar: {
    flex: '0 0 190px',
    position: 'sticky',
    top: '72px',
    '@media (max-width: 800px)': {
      position: 'static',
      flex: '1 1 auto',
      width: '100%',
    },
  },
  modeRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    marginBottom: '1rem',
    '@media (max-width: 800px)': {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  modeButton: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.95rem',
    color: theme.palette.text.secondary,
    padding: '0.35rem 0.6rem',
    borderRadius: '8px',
  },
  modeActive: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action ? theme.palette.action.selected : 'rgba(0,0,0,0.08)',
  },
  catHeader: {
    fontSize: '0.72rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: theme.palette.text.secondary,
    opacity: 0.7,
    margin: '0.75rem 0 0.5rem',
  },
  catList: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 800px)': {
      flexDirection: 'row',
      flexWrap: 'nowrap',
      gap: '0.35rem',
      overflowX: 'auto',
      paddingBottom: '0.5rem',
      WebkitOverflowScrolling: 'touch',
    },
  },
  catLink: {
    textDecoration: 'none',
    color: theme.palette.text.secondary,
    padding: '0.3rem 0.6rem',
    borderRadius: '8px',
    fontSize: '0.95rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    '&:hover': { color: theme.palette.text.primary },
  },
  catLinkActive: {
    color: `${theme.palette.text.primary} !important`,
    fontWeight: 700,
    backgroundColor: theme.palette.action ? theme.palette.action.selected : 'rgba(0,0,0,0.08)',
  },
  main: {
    flex: 1,
    minWidth: 0,
  },
  heading: {
    margin: '0 0 0.25rem',
    fontSize: '1.5rem',
    fontWeight: 800,
  },
  subheading: {
    margin: '0 0 1.25rem',
    color: theme.palette.text.secondary,
    fontSize: '0.95rem',
  },
  search: {
    marginBottom: '1.25rem',
    maxWidth: '420px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
    gap: '1.5rem',
  },
  loadMoreRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: '2rem 0',
  },
  empty: {
    padding: '3rem 0',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
});

export default styles;
